<template>
  <div class="statistics-entered">
    <div class="ly-card hd">
      <el-select class="m-r-10" v-model="searchFormData.year" placeholder="学年">
        <el-option v-for="item in years" :key="item.value" :label="item.label" :value="item.value"> </el-option>
      </el-select>
      <el-select class="m-r-10" v-model="searchFormData.term" placeholder="学期">
        <el-option v-for="item in terms" :key="item.value" :label="item.label" :value="item.value"> </el-option>
      </el-select>
      <el-select
        class="m-r-10"
        v-model="searchFormData.org_id"
        placeholder="部门"
        @change="getRootSp"
        @clear="search"
        filterable
        clearable
      >
        <el-option v-for="item in org_ids" :key="item.id" :label="item.name" :value="item.id"> </el-option>
      </el-select>
      <el-select
      class="m-r-10"
        v-model="searchFormData.root_specialized_subject_id"
        placeholder="项目大类"
        :disabled="!searchFormData.org_id"
        @clear="search"
        @change="getSp"
        filterable
        clearable
      >
        <el-option v-for="item in root_specialized_subject_ids" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <el-select
      class="m-r-10"
        @clear="search"
        @change="search"
        v-model="searchFormData.specialized_subject_id"
        placeholder="项目"
        filterable
        clearable
        :disabled="!searchFormData.org_id || !searchFormData.root_specialized_subject_id"
      >
        <el-option v-for="item in specialized_subject_ids" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <el-input class="m-r-10" clearable style="width: 220px"  v-model.trim="searchFormData.query" placeholder="班级名称"></el-input>
      <!-- <el-button size="medium" @click="reset">重置</el-button> -->
      <el-button  type='primary' @click="search">查询</el-button>
      <el-button  type='primary' @click="exportExcel">导出</el-button>
    </div>
    <div class="ly-card">
      <table v-loading="loading"
        class="native-table">
          <tr style='font-weight: bold'>
            <td colspan="5">总计</td>
            <td>{{totalTableData.statistics_total_fee}}</td>
            <td>{{totalTableData.statistics_reserved_count}}/{{totalTableData.statistics_class_reserved_count}}</td>
            <td>{{totalTableData.statistics_class_size}}</td>
            <td>{{totalTableData.statistics_edu_count}}</td>

            <td>{{totalTableData.statistics_minister_count}}</td>
            <td>{{totalTableData.statistics_group_count}}</td>
            <td>{{totalTableData.statistics_website_count}}</td>
            <td>{{totalTableData.statistics_pay_count}}</td>
            <td></td>
          </tr>
          <tr>
            <th>班级名称</th>
            <th>项目</th>
            <th>教师</th>
            <th>开课时间</th>
            <th>结课时间</th>
            <th>总费用</th>
            <th>预留报名/预留</th>
            <th>预招</th>
            <th>教务报名</th>
            <th>部长报名</th>
            <th>集体报名</th>
            <th>外网报名</th>
            <th>缴费人数</th>
            <th>操作</th>
          </tr>
          <tr v-for="(item,index) in getTableData" :key="`${item.name}/${index}`">
            <td>{{item.name}}</td>
            <td>{{item.fee_level.specialized_subject_name}}</td>
            <td>{{teacherFilter(item.teacher)}}</td>
            <td>{{item.first_class_start_time}}</td>
            <td>{{item.last_class_end_time}}</td>
            <td>{{item.statistic_data.statistics_total_fee}}</td>
            <td>{{item.statistic_data.statistics_reserved_count}}/{{item.reserved_count}}</td>
            <td>{{item.class_size}}</td>
            <td>{{item.statistic_data.statistics_edu_count}}</td>
            <td>{{item.statistic_data.statistics_minister_count}}</td>
            <td>{{item.statistic_data.statistics_group_count}}</td>
            <td>{{item.statistic_data.statistics_website_count}}</td>
            <td>{{item.statistic_data.statistics_pay_count}}</td>
            <td>
              <el-button type="text" size="mini" @click="enterInf(item)">报名详情</el-button>
            </td>
          </tr>
      </table>
      <el-pagination
        class='ly-pagination'
        @size-change="handlePageChange"
        @current-change="handleCurrentChange"
        layout="prev, pager, next, -> ,sizes, total"
        :total="this.total"
        :page-sizes="[pageSize,pageSize*2,pageSize*3,pageSize*10]"
      />
    </div>
  </div>
</template>
<script>
import { Select, Option, Input, Pagination } from 'element-ui';
import { report, finance } from '@/api';
import utils from '@/utils/utils';

export default {
  name: 'statisticsEntered',
  components: {
    ElSelect: Select,
    ElOption: Option,
    ElInput: Input,
    ElPagination: Pagination

  },
  data() {
    return {
      loading: true,
      searchFormData: {
        org_id: '',
        year: `${new Date().getFullYear()}`,
        term: '',
        specialized_subject_id: '',
        root_specialized_subject_id: '',
        contract_type: '',
        contract_status: 2,
        query: '',
        page_no: 1,
        page_size: 20
      },
      total: 0,
      pageSize: 20,
      years: [],
      terms: [],
      org_ids: [],
      root_specialized_subject_ids: [],
      specialized_subject_ids: [],
      contract_types: [],
      contract_statues: [],
      getTableData: {},
      totalTableData: {}
    };
  },
  mounted() {
    this.$store.dispatch('schoolYear/getTermAndYearList').then(data => {
      if (data) {
        this.years = data.year;
        this.terms = data.term;
        this.searchFormData.term = data.term[0].value;
        this.search();
      }
    });
    this.getOrg();
  },
  computed: {
    label() {
      return value => {
        if (value) return this.terms.find(item => item.value === value).label;
        return '';
      };
    }
  },
  methods: {
    handleCurrentChange(page) {
      this.searchFormData.page_no = page;
      this.search();
    },
    handlePageChange(pageSize) {
      this.searchFormData.page_size = pageSize;
      this.searchFormData.page_no = 1;
      this.search();
    },
    teacherFilter(value) {
      return (value || []).map(item => item.real_name).join(',');
    },
    getOrg() {
      finance.orgQuery().then(res => {
        if (res) {
          this.org_ids = res.data.list;
        }
      });
    },
    changeOrg(row) {
      this.searchFormData.org_id = row.org_id;
      this.getRootSp();
    },
    getRootSp() {
      this.searchFormData.specialized_subject_id = '';
      this.searchFormData.root_specialized_subject_id = '';
      if (this.searchFormData.org_id) {
        finance.rootSpecializedSubjectQuery({ org_id: this.searchFormData.org_id }).then(res => {
          if (res) {
            this.root_specialized_subject_ids = res.data.list;
          }
        });
      } else {
        this.root_specialized_subject_ids = [];
      }
      this.search();
    },
    getSp() {
      this.searchFormData.specialized_subject_id = '';
      if (this.searchFormData.org_id && this.searchFormData.root_specialized_subject_id) {
        finance
          .specializedSubjectQuery({
            org_id: this.searchFormData.org_id,
            root_specialized_subject_id: this.searchFormData.root_specialized_subject_id
          })
          .then(res => {
            if (res) {
              this.specialized_subject_ids = res.data.list;
            }
          });
      } else {
        this.specialized_subject_ids = [];
      }
      this.search();
    },
    search() {
      this.loading = true;
      const temp = { ...this.searchFormData };
      Object.keys(temp).forEach(key => {
        const value = temp[key];
        if (value && value !== -1) temp[key] = value;
        else delete temp[key];
      });
      report.getClassSignUpStatistics(temp).then(res => {
        if (res) {
          this.getTableData = res.data.list;
          this.total = res.data.total;
        }
      });
      report.getClassSignUpTotal(temp).then(res => {
        if (res) {
          this.totalTableData = res.data.total;
        }
        this.loading = false;
      });
    },
    enterInf(row) {
      const routeUrl = this.$router.resolve(
        `/${this.$route.params.user_id}/classes/enrolment/${row.id}?class_phase=1&name=${row.name}&fee_level=${row.fee_level.specialized_subject_name}`
      );
      window.open(routeUrl.href, '_blank');
    },
    exportExcel() {
      const params = { ...this.searchFormData };
      Object.keys(params).forEach(key => {
        if (params[key] === '' || params[key] === null) delete params[key];
      });
      report
        .exportBackStudyRate({
          params
        })
        .then(data => {
          if (data) utils.downloadData(data, '班级报名统计');
        });
    }
  }
};
</script>
<style lang="less">
.statistics-entered {
  .el-select {
    width: 160px;
  }
  .ly-search-comp {
    display: inline-block;
    width: 180px;
    .el-select {
      width: 100%;
    }
  }
  .el-input {
    width: 100%;
    height:36px;
    line-height: 36px;
    input{
      height:36px;
      line-height: 36px;
    }
  }
  > * {
    margin: 0 10px;
  }
  .ly-pagination {
    text-align: center;
    margin-top: 10px;
  }
}
</style>
